import HigherEducation from "./HigherEducation"

export default HigherEducation
